(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('RunnerRaceResume', RunnerRaceResume);

    RunnerRaceResume.$inject = ['$resource', 'DateUtils'];

    function RunnerRaceResume ($resource, DateUtils) {
        var resourceUrl =  'api/runner-race-resumes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.finishDate = DateUtils.convertDateTimeFromServer(data.finishDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
